import usePrevious from './usePrevious';

const CustomHooks = {
  usePrevious,
};

export default CustomHooks;
